import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroSection() {
  const featuredComics = comics.filter((c) => c.isHot).slice(0, 3);

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center bg-background-50 overflow-hidden pt-16">
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 pt-12 md:pt-20 pb-8 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
          韩国免费漫画
        </h1>
        <p className="text-lg md:text-2xl font-heading text-foreground-900 mt-3">
          韩漫大全 —— 下拉式漫画在线阅读
        </p>
        <p className="text-sm md:text-base text-foreground-600 mt-4 max-w-xl mx-auto leading-relaxed">
          海量免费韩国漫画，全题材覆盖，下拉式畅快阅读，每日更新
        </p>

        <Link
          to="/category/romance"
          className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-foreground-950 text-background-50 font-medium text-sm rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          开始阅读
          <i className="ri-arrow-right-line text-base" />
        </Link>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 pb-20">
        <div className="relative flex items-end justify-center gap-2 md:gap-4">
          {featuredComics.map((comic, index) => {
            const isCenter = index === 1;
            return (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className={`relative cursor-pointer transition-transform duration-300 hover:scale-105 ${
                  isCenter
                    ? 'w-[140px] md:w-[180px] -mt-6 z-20'
                    : `w-[110px] md:w-[150px] z-10 ${index === 0 ? 'rotate-[-4deg]' : 'rotate-[4deg]'}`
                }`}
                data-product-shop
              >
                <div className="rounded-xl overflow-hidden bg-background-100 border-2 border-background-50">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 韩国漫画网`}
                    className="w-full aspect-[3/4] object-cover object-top"
                    loading={index === 1 ? 'eager' : 'lazy'}
                  />
                </div>
                <p className={`mt-2 text-center font-medium truncate ${
                  isCenter ? 'text-sm md:text-base text-foreground-900' : 'text-xs md:text-sm text-foreground-600'
                }`}>
                  {comic.title}
                </p>
              </Link>
            );
          })}
        </div>
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-primary-50/30 via-transparent to-transparent pointer-events-none" />
    </section>
  );
}